import { createFileRoute } from "@tanstack/react-router";
import { PreviewPage } from "../../../../../components/app/preview-page";

export const Route = createFileRoute("/_authed/a/$slug/preview/$draftId")({
  component: PreviewRoute,
});

function PreviewRoute() {
  const { slug, draftId } = Route.useParams();
  return <PreviewPage key={draftId} slug={slug} draftId={draftId} />;
}
